// Zentrale Versionsnummer für die gesamte Anwendung
// Diese Datei sollte die einzige Quelle für die Frontend-Versionsnummer sein

export const FRONTEND_VERSION = '0.1.131';
export const PRODUCT_NAME = 'ZEITAUF-MOBIL';
export const COPYRIGHT_YEAR = '2026';
export const COPYRIGHT_HOLDER = 'Thomas Küssner';

// Formatierte Version für Anzeige
export const getVersionString = () => `v${FRONTEND_VERSION}`;

// Vollständiger Footer-Text (copyright kommt aus i18n t('app.copyright'))
export const getFooterText = (t) => ({
  productName: PRODUCT_NAME,
  version: getVersionString(),
  copyright: t ? t('app.copyright') : `© ${COPYRIGHT_YEAR} ${COPYRIGHT_HOLDER}`
});
